export const getSelectedTagTemplate = (id: number, name: string, color: string): string => {
  return `<button class="task-filter__remove tag tag--slim js-tag-change-remove" data-id="${id}" style="background-color:${color};">${name}<span class="tag__remove"></span></button>`;
};
